<script setup>
    // items
    const list = defineModel()

    const items = computed( () => {
        return ( list.value ) ? list.value : []
    })


    // const { items } = defineProps({
    //     items: Array
    // })

    const visible_count = 4
    const result_count = ref( visible_count )
    const way_count = ref(0)
    const visible_number = ref(0)

    const photos = computed( () => {

        let _items = items.value.map( ( ph, i ) => {
            return {
                url: ph,
                visible: (i == visible_number.value) ? true : false
            }
        })

        if( _items.length > visible_count ){
            result_count.value = visible_count
            way_count.value = _items.length - visible_count
            _items = _items.slice(0, visible_count)
        }
        else{
            result_count.value = _items.length
        }

        // if( items.length > 0 ){
        //     way_count.value = 0
        //     result_count.value = 1
        //     _items = [{
        //         url: 'no-photo',
        //         visible: true
        //     }]
        // }

        return _items

    })

    const moveItem = _i => {
        visible_number.value = --_i
    }

    // watch( items, new_items => {
    //     items.value = new_items.value
    //     console.log('--new_items--', new_items);
    // }, {
    //     deep: true
    // })

    // onUpdated( () => {
    //     console.log('--new_items--', items);
    // })

</script>
<template>
    <div v-if="items.length > 0">
        <div class="absolute w-full h-full flex flex-row justify-around z-10">
            <div 
                v-for="_i in result_count"
                @pointermove="moveItem( _i )"
                @pointerleave="moveItem( 1 )"
                class="w-full h-full grid content-end group">
                    <div class="h-1 bg-slate-600 group-hover:bg-slate-200 w-full mb-0.5"></div>
            </div>
            <div
                v-if="way_count > 0" 
                @pointermove="moveItem( visible_count + 1 )"
                @pointerleave="moveItem( 1 )"
                class="w-full h-full grid content-end group">
                    <div class="h-1 bg-slate-600 group-hover:bg-slate-200 w-full mb-0.5"></div>
            </div>
        </div>
        <div class="w-full h-[290px]" >
            <div v-if="way_count > 0" class="bg-cover  bg-no-repeat bg-center text-white w-full h-full absolute z-0" :style="{ backgroundImage: `url(${photos[photos.length-1].url}?_)` }" >
                <div class="absolute w-full h-full backdrop-blur-sm bg-black/30  grid justify-center content-center text-4xl font-thin">
                    {{ way_count }}+
                </div>
            </div>
            <template v-for="photo in photos">
                <div 
                    v-if="photo.visible"
                    class="bg-cover bg-no-repeat bg-center w-full h-full absolute z-0"
                    :style="{ backgroundImage: `url(${photo.url}?_)` }"
                ></div>
            </template>
        </div>
    </div>
    <div v-if="items.length == 0" class="w-full h-[290px]" >
        <div 
            class="bg-cover bg-no-repeat bg-center w-full h-full absolute z-0"
            :style="{ backgroundImage: `url(/img/no-photo.png)` }"
        ></div>
    </div>
</template>